import Vue from 'vue'
import ReviewBoxVue from './main.vue'

const ReviewBoxConstructor = Vue.extend(ReviewBoxVue)

let instance

const initInstance = () => {
  instance = new ReviewBoxConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const showDialog = function (visibleName, options) {
  if (!instance) {
    initInstance()
  }
  // 恢复默认值
  Object.assign(instance.$data, instance.$options.data())
  // 显示窗口
  instance.visible[visibleName] = true
  // 设置其他选项
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
}

const ReviewBox = function () {
  return ReviewBox
}

ReviewBox.orderConfirm = function (callback, salary, photos, orderDetail) {
  let options = {}
  // 直接传入 callback
  if (typeof callback === 'function') {
    options.callback = callback
  } else {
    options = callback
  }
  // 附带 salary 的参数
  if (salary !== undefined) {
    // 数字格式化
    options.salary = Number(salary)
  }
  if (photos && photos.length) {
    options.marketPhotos = photos
  }
  if (orderDetail !== undefined) {
    options.orderDetail = orderDetail
  }

  let components = {
    message: false,
    customSalary: true,
  }
  if (options.components === undefined) {
    options.components = {}
  }
  options.components = {...components, ...options.components}
  showDialog('orderConfirm', options)
}

ReviewBox.orderReConfirm = function (callback, salary) {
  let options = {}
  // 直接传入 callback
  if (typeof callback === 'function') {
    options.callback = callback
  } else {
    options = callback
  }
  // 附带 salary 的参数
  if (salary !== undefined) {
    // 数字格式化
    options.salary = Number(salary)
  }
  let components = {
    message: true,
    customSalary: false,
  }
  if (options.components === undefined) {
    options.components = {}
  }
  options.components = {...components, ...options.components}
  showDialog('orderConfirm', options)
}

ReviewBox.orderBack = function (callback) {
  let options = {}
  // 直接传入 callback
  if (typeof callback === 'function') {
    options.callback = callback
  } else {
    options = callback
  }
  let components = {
    prolongTime: true,
  }
  if (options.components === undefined) {
    options.components = {}
  }
  options.components = {...components, ...options.components}
  showDialog('orderBack', options)
}


ReviewBox.orderReBack = function (callback) {
  let options = {}
  // 直接传入 callback
  if (typeof callback === 'function') {
    options.callback = callback
  } else {
    options = callback
  }
  let components = {
    prolongTime: true,
  }
  if (options.components === undefined) {
    options.components = {}
  }
  options.components = {...components, ...options.components}
  showDialog('orderBack', options)
}

ReviewBox.questionNotPassed = function (callback) {
  let options = {}
  // 直接传入 callback
  if (typeof callback === 'function') {
    options.callback = callback
  } else {
    options = callback
  }
  showDialog('questionNotPassed', options)
}

ReviewBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default ReviewBox
export { ReviewBox }



// WEBPACK FOOTER //
// ./src/views/question-review/components/ReviewBox/src/main.js